import RangeSlider from './components/RangeSlider/RangeSlider'
import SingleSlider from './components/SingleSlider/SingleSlider'

const Slider = {
  Single: SingleSlider,
  Range: RangeSlider,
}

export default Slider
